import angular from 'angular';

export default angular.module('slviz.filtersModule', [

])
    .filter('capitalize', function () {
    return function (input) {
        return (!!input) ? input.charAt(0).toUpperCase() + input.substr(1).toLowerCase() : '';
    };
}).name;



// WEBPACK FOOTER //
// ./src/js/filters.js